import React, { useState } from "react";

import Drawer from "../../../../../components/drawer/Drawer";
import ManageBlog from "../../../../../components/sections/admin/Blog/ManageBlog";

const ManageBlogDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [previousSize, setPreviousSize] = useState(() => {
    return localStorage.getItem("drawer-previous-size") || "";
  });

  return (
    <Drawer
      open={open}
      onClose={(val) => {
        setSelectedTab(0);
        close(val);
      }}
      size={
        previousSize
          ? previousSize
          : [0, 1].includes(selectedTab)
          ? "xl5"
          : "xl6"
      }
      title={data?._id ? "Edit Post" : "Add Post"}
      subtitle="View, update and modify Post details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      closeBtn={true}
    >
      <div className="h-full overflow-y-auto">
        <ManageBlog
          getResponse={getResponse}
          close={(val) => {
            setSelectedTab(0);
            close(val);
          }}
          data={data}
          selectedTab={selectedTab}
          setSelectedTab={(val) => {
            setPreviousSize(localStorage.getItem("drawer-previous-size") || "");
            setSelectedTab(val);
          }}
        />
      </div>
    </Drawer>
  );
};

export default ManageBlogDrawer;
